/* eslint-disable import/prefer-default-export */
import styled from 'styled-components';
import is from 'is_js';
import colors from '../../../assets/colors';

export const Dropdown = styled.div`
  width: 294px;
  padding: 10px 0 7px;
  position: relative;
  top: -25px;
  right: ${is.chrome() ? '1px' : '0'};
  float: right;
  z-index: 10;
  background-color: #2B2B2B;
  border-radius: 10px;
  border-top-left-radius: 0;
  border-top-right-radius: 0;

  ul {
    list-style: none;
    margin: 0;
    padding: 0;
  }

  li > a {
    display: flex;
    padding: 6px 14px;
    color: #777777;
    font-size: 0.9rem;
    font-weight: 600;
    text-decoration: none;
    cursor: pointer;
  }

  .active, a:hover {
    color: ${colors.white};
    background: ${colors.primary};
  }

  @media screen and (max-width: 1089px) {
    display: none;
  }
`;
